import { IPageLink } from '@vivli/shared/infrastructure/interface';
import { VerticalNavTabView } from './vertical-nav-tab.view';
import { CSSProperties } from 'react';

const containerStyle: CSSProperties = {
    minWidth: 200,
    backgroundColor: '#fff',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'repeat(auto-fill, minmax(70px, 30px))',
};

export interface VerticalNavProps {
    links: IPageLink[];
    activeLink?: IPageLink;
    onTabClick?: (link: IPageLink) => void;
    isLoading?: boolean;
}

export const VerticalNavView = ({ links, activeLink, onTabClick, isLoading }: VerticalNavProps) => {
    const handleLinkClick = (link: IPageLink) => {
        onTabClick && onTabClick(link);
    };

    return (
        <div style={containerStyle}>
            {links
                .filter((l) => !l.hidden) // do not show any hidden links
                ?.map((link) => (
                    <VerticalNavTabView
                        key={link.url}
                        title={link.title}
                        url={link.url}
                        active={activeLink?.url === link.url}
                        onTabClick={() => handleLinkClick(link)}
                        isDisabled={isLoading && activeLink?.url !== link.url}
                        isLoading={isLoading && activeLink?.url !== link.url}
                    />
                ))}
        </div>
    );
};
